import { RevealSection } from './components/RevealSection';
import heroDubai from './assets/images/hero-dubai.png';
import marbleInterior from './assets/images/marble-interior.png';
import infinityPool from './assets/images/infinity-pool.png';
import luxuryCorridor from './assets/images/luxury-corridor.png';
import abstractGold from './assets/images/abstract-gold.png';
import founderPortrait from './assets/images/founder-portrait.jpg';
import logoGold from './assets/images/logo-gold.png';
import brandSky from './assets/images/brand-sky.png';
import handshake from './assets/images/handshake.png';
import palaceCeiling from './assets/images/palace-ceiling.jpg';
import grandFacade from './assets/images/grand-facade.jpg';
import ahMonogram from './assets/images/ah-monogram.png';
import luxuryDesk from './assets/images/luxury-desk.png';

function App() {
  return (
    <div className="relative min-h-screen bg-[#050505] overflow-x-hidden">

      {/* ===== HERO SECTION — FULL CINEMATIC ===== */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Background: Dubai skyline */}
        <div className="absolute inset-0 animate-hero">
          <img src={heroDubai} alt="" className="w-full h-full object-cover scale-105 img-warm" />
          <div className="luxury-overlay absolute inset-0" />
          <div className="cinematic-vignette absolute inset-0" />
        </div>

        {/* Gold atmospheric light */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[1000px] opacity-25 animate-gold-pulse"
             style={{ background: 'radial-gradient(ellipse at top, rgba(212,151,15,0.5) 0%, transparent 60%)' }} />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[200px] bg-gradient-to-t from-[#050505] to-transparent z-10" />



        {/* Hero Content */}
        <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
          <h1 className="font-arabic text-5xl md:text-7xl lg:text-8xl font-bold leading-[1.2] mb-10 animate-text-2">
            <span className="gold-gradient-text text-glow-gold">العلامات التي تفهم الجيل القادم</span>
            <br />
            <span className="text-white text-glow-white">هي التي تقود السوق</span>
          </h1>

          <div className="space-y-6 animate-text-3">
            <p className="font-arabic text-xl md:text-2xl text-white/60 leading-relaxed max-w-3xl mx-auto">
              معظم العلامات الفاخرة لا تعاني من مشكلة استراتيجية
              <br />
              بل من مشكلة في الإدراك
            </p>
            <p className="font-arabic text-3xl md:text-4xl gold-gradient-text font-bold mt-8 text-glow-gold">
              نحن نحل الاثنين
            </p>
          </div>

          <p className="font-arabic text-base text-white/30 mt-20 tracking-wide animate-text-4">
            لمن يفهم أن الإدراك هو القيمة الحقيقية
          </p>
        </div>
      </section>

      {/* ===== BRAND VISION — SKY IMAGE ===== */}
      <section className="relative h-[80vh] md:h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img src={brandSky} alt="" className="w-full h-full object-cover" style={{ filter: 'brightness(0.6) saturate(1.2)' }} />
          <div className="luxury-overlay-top absolute inset-0" />
          <div className="cinematic-vignette absolute inset-0" />
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <RevealSection>
            <img src={logoGold} alt="" className="h-16 w-auto mx-auto mb-12 opacity-80" style={{ filter: 'drop-shadow(0 0 20px rgba(212,151,15,0.3))' }} />
            <h2 className="font-arabic text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.2] text-glow-gold">
              <span className="gold-gradient-text">العقد القادم من الفخامة</span>
              <br />
              <span className="text-white/95">يتم حسمه الآن</span>
            </h2>
          </RevealSection>
        </div>
      </section>

      {/* ===== DIAGNOSIS — PALACE CEILING ===== */}
      <section className="relative py-40 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img src={palaceCeiling} alt="" className="w-full h-full object-cover img-warm" />
          <div className="absolute inset-0 bg-[#050505]/80" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <RevealSection>
            <p className="font-arabic text-2xl md:text-3xl text-white/65 leading-loose max-w-3xl mx-auto mb-16">
              جيل Z والجيل الألفي يمثلون
              <br />
              أكبر وأسرع شريحة نمو في سوق الفخامة
            </p>
          </RevealSection>

          <RevealSection delay={300}>
            <p className="font-arabic text-xl md:text-2xl text-white/45 leading-loose max-w-2xl mx-auto">
              ومع ذلك
              <br />
              لا تزال معظم العلامات تتحدث
              <br />
              إلى جمهور لم يعد يقود السوق
            </p>
          </RevealSection>

          <RevealSection delay={600}>
            <div className="gold-line w-48 mx-auto mt-20 mb-12" />
            <p className="font-arabic text-xl text-gold-400/80">
              ما يتم إنتاجه يبدو واضحاً فوراً
            </p>
            <p className="font-arabic text-lg text-white/35 mt-2">
              محاولات… وليس فهماً
            </p>
          </RevealSection>
        </div>
      </section>

      {/* ===== DATA — VISUAL DOMINANT ===== */}
      <section className="relative py-40 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img src={abstractGold} alt="" className="w-full h-full object-cover opacity-30" style={{ filter: 'hue-rotate(-10deg) saturate(1.5)' }} />
          <div className="absolute inset-0 bg-[#050505]/70" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 text-center items-center min-h-[60vh]">
            <RevealSection>
              <div className="space-y-6 py-12">
                <p className="font-arabic text-8xl md:text-9xl lg:text-[10rem] font-bold gold-gradient-text text-glow-gold leading-none">
                  ٧٣٪
                </p>
                <p className="font-arabic text-lg md:text-xl text-white/55 leading-relaxed max-w-xs mx-auto">
                  من نمو الفخامة يقوده من هم دون ٤٥
                </p>
              </div>
            </RevealSection>

            <RevealSection delay={400}>
              <div className="space-y-6 py-12">
                <p className="font-arabic text-6xl md:text-7xl font-bold text-white text-glow-white leading-none">
                  جيل Z
                </p>
                <p className="font-arabic text-lg md:text-xl text-white/55 leading-relaxed max-w-xs mx-auto">
                  أكبر قوة صاعدة في السوق
                </p>
              </div>
            </RevealSection>

            <RevealSection delay={800}>
              <div className="space-y-6 py-12">
                <p className="font-arabic text-8xl md:text-9xl lg:text-[10rem] font-bold gold-gradient-text text-glow-gold leading-none">
                  ١٠
                </p>
                <p className="font-arabic text-lg md:text-xl text-white/55 leading-relaxed max-w-xs mx-auto">
                  تحديات لا تستطيع معظم العلامات حلها
                </p>
              </div>
            </RevealSection>
          </div>
        </div>
      </section>

      {/* ===== DILEMMAS — GRAND FACADE ===== */}
      <section className="relative py-40 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img src={grandFacade} alt="" className="w-full h-full object-cover img-cinematic" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-burgundy-950/40 to-[#050505]/95" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto">
          <RevealSection>
            <h2 className="font-arabic text-4xl md:text-6xl font-bold text-center leading-[1.3] mb-20">
              <span className="text-white text-glow-white">ما لا تستطيع معظم العلامات الفاخرة</span>
              <br />
              <span className="gold-gradient-text text-glow-gold">حله بمفردها</span>
            </h2>
          </RevealSection>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {[
              'الأصالة مقابل الطموح',
              'الحضور الرقمي مقابل الحصرية',
              'محتوى بلا روح',
              'الاستدامة مقابل قيمة العلامة',
              'الخوارزميات مقابل الحرفة',
              'إرهاق المؤثرين',
              'القصة مقابل الأداء',
              'الملاءمة الثقافية مقابل التموضع',
              'علامة عالمية مقابل ثقة محلية',
              'السرعة مقابل النية',
            ].map((item, i) => (
              <RevealSection key={i} delay={i * 100}>
                <div className="card-luxury p-6 md:p-7 rounded-sm relative overflow-hidden group">
                  <div className="absolute top-0 right-0 w-full h-[1px] bg-gradient-to-l from-gold-500/30 to-transparent 
                                opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                  <p className="font-arabic text-lg md:text-xl text-white/80 group-hover:text-white transition-colors duration-500">
                    {item}
                  </p>
                </div>
              </RevealSection>
            ))}
          </div>
        </div>
      </section>

      {/* ===== GENERATION GAP — INFINITY POOL ===== */}
      <section className="relative h-[80vh] md:h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img src={infinityPool} alt="" className="w-full h-full object-cover img-cinematic" />
          <div className="luxury-overlay-top absolute inset-0" />
          <div className="cinematic-vignette absolute inset-0" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto text-center px-6">
          <RevealSection>
            <h2 className="font-arabic text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.2] mb-12 text-glow-white">
              <span className="text-white">لا يمكنك دراسة جيل</span>
              <br />
              <span className="gold-gradient-text text-glow-gold">من الخارج</span>
            </h2>
          </RevealSection>

          <RevealSection delay={300}>
            <p className="font-arabic text-2xl md:text-3xl text-white/55 leading-relaxed">
              كل وكالة تنتج تقارير
            </p>
            <p className="font-arabic text-2xl md:text-3xl text-white/85 mt-4 leading-relaxed">
              والجيل لا يرى نفسه فيها
            </p>
          </RevealSection>

          <RevealSection delay={600}>
            <div className="gold-line w-32 mx-auto mt-20 mb-10" />
            <p className="font-arabic text-2xl text-gold-300 font-semibold">
              الفهم الحقيقي لا يُدرس
            </p>
            <p className="font-arabic text-3xl gold-gradient-text font-bold mt-3 text-glow-gold">
              بل يُعاش
            </p>
          </RevealSection>
        </div>
      </section>

      {/* ===== THE BRIDGE — LUXURY DESK ===== */}
      <section className="relative py-40 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img src={luxuryDesk} alt="" className="w-full h-full object-cover" style={{ filter: 'brightness(0.5) saturate(1.1)' }} />
          <div className="absolute inset-0 bg-[#050505]/50" />
          <div className="cinematic-vignette absolute inset-0" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <RevealSection>
            <h2 className="font-arabic text-5xl md:text-7xl lg:text-8xl font-bold leading-[1.15] mb-10">
              <span className="gold-gradient-text text-glow-gold">ذكاء فاخر</span>
              <br />
              <span className="text-white text-glow-white">وفهم عميق للأجيال</span>
            </h2>
          </RevealSection>

          <RevealSection delay={400}>
            <div className="gold-line w-24 mx-auto my-12" />
            <p className="font-arabic text-2xl md:text-3xl text-white/60 leading-relaxed">
              ليس اختياراً بين الاثنين
            </p>
            <p className="font-arabic text-2xl md:text-3xl gold-gradient-text font-bold mt-4 text-glow-gold">
              بل إتقان الاثنين
            </p>
          </RevealSection>
        </div>
      </section>

      {/* ===== FOUNDER — CINEMATIC SPLIT ===== */}
      <section className="relative py-32 md:py-40 px-6 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#0d0906] to-[#050505]" />
        {/* Subtle marble texture behind */}
        <div className="absolute inset-0 opacity-[0.04]">
          <img src={marbleInterior} alt="" className="w-full h-full object-cover" />
        </div>

        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 items-center">
            {/* Portrait — larger, more dramatic */}
            <div className="lg:col-span-2">
              <RevealSection>
                <div className="relative">
                  <div className="absolute -inset-4 opacity-20 rounded-sm" style={{ background: 'radial-gradient(ellipse, rgba(212,151,15,0.3), transparent 70%)' }} />
                  <div className="relative overflow-hidden rounded-sm border border-gold-700/20">
                    <img
                      src={founderPortrait}
                      alt="Anett Horvath"
                      className="w-full object-cover aspect-[3/4]"
                      style={{ filter: 'contrast(1.08) saturate(1.05) brightness(0.95)' }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/50 via-transparent to-transparent" />
                  </div>
                  <div className="gold-line w-full mt-4" />
                </div>
              </RevealSection>
            </div>

            {/* Content */}
            <div className="lg:col-span-3 space-y-10">
              <RevealSection delay={200}>
                <h2 className="font-arabic text-4xl md:text-5xl font-bold gold-gradient-text text-glow-gold mb-3">
                  أنيت هورفاث
                </h2>
                <p className="font-arabic text-2xl text-white/55">
                  الجسر النادر بين عالمين
                </p>
              </RevealSection>

              <RevealSection delay={400}>
                <div className="space-y-8">
                  <p className="font-arabic text-xl md:text-2xl text-white/65 leading-loose">
                    بنت توزيعاً فعلياً
                    <br />
                    داخل مطار بودابست الدولي
                  </p>
                  <p className="font-arabic text-xl md:text-2xl text-white/65 leading-loose">
                    وتعمل على مستوى الفخامة
                    <br />
                    بشكل طبيعي
                  </p>
                </div>
              </RevealSection>

              <RevealSection delay={600}>
                <div className="border-r-2 border-gold-500/40 pr-8 py-4 mt-8">
                  <p className="font-arabic text-2xl md:text-3xl text-gold-300/90 leading-relaxed font-semibold">
                    أندر ميزة ليست الخبرة
                    <br />
                    بل القدرة على الرؤية من زاويتين
                  </p>
                </div>
              </RevealSection>
            </div>
          </div>
        </div>
      </section>

      {/* ===== TEAM — CORRIDOR ===== */}
      <section className="relative py-40 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img src={luxuryCorridor} alt="" className="w-full h-full object-cover img-cinematic" />
          <div className="absolute inset-0 bg-gradient-to-b from-burgundy-950/80 via-[#050505]/70 to-[#050505]/90" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <RevealSection>
            <h2 className="font-arabic text-4xl md:text-6xl font-bold leading-[1.3] mb-20">
              <span className="text-white text-glow-white">لسنا مستشارين يدرسون الجمهور</span>
              <br />
              <span className="gold-gradient-text text-glow-gold">نحن الجمهور</span>
            </h2>
          </RevealSection>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { title: 'جيل Z من الداخل', desc: 'فهم عضوي لا يُكتسب من التقارير' },
              { title: 'تنفيذ إبداعي', desc: 'من الرؤية إلى الواقع' },
              { title: 'تفكير معقد', desc: 'حل مشكلات لا تراها الأغلبية' },
              { title: 'فريق يجمع العالمين', desc: 'الفخامة والجيل الجديد' },
            ].map((item, i) => (
              <RevealSection key={i} delay={i * 200}>
                <div className="card-luxury p-10 rounded-sm text-center">
                  <h3 className="font-arabic text-2xl md:text-3xl font-bold text-white mb-4">
                    {item.title}
                  </h3>
                  <p className="font-arabic text-lg text-white/45">
                    {item.desc}
                  </p>
                </div>
              </RevealSection>
            ))}
          </div>
        </div>
      </section>

      {/* ===== SERVICES — MARBLE ===== */}
      <section className="relative py-40 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img src={marbleInterior} alt="" className="w-full h-full object-cover" style={{ filter: 'brightness(0.15) saturate(0.7)' }} />
          <div className="absolute inset-0 bg-[#050505]/60" />
        </div>

        <div className="relative z-10 max-w-6xl mx-auto">
          <RevealSection>
            <h2 className="font-arabic text-4xl md:text-6xl font-bold text-center leading-tight mb-24">
              <span className="gold-gradient-text text-glow-gold">نحل ما لا يستطيع الآخرون حله</span>
            </h2>
          </RevealSection>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              'تحليل العلامة للأجيال',
              'بناء الأصالة',
              'محتوى بروح',
              'تصميم الحضور الرقمي',
              'فهم الثقافة',
              'بناء النظام الكامل',
            ].map((service, i) => (
              <RevealSection key={i} delay={i * 120}>
                <div className="card-luxury p-10 rounded-sm text-center min-h-[140px] flex items-center justify-center">
                  <p className="font-arabic text-xl md:text-2xl text-white/80 font-semibold">
                    {service}
                  </p>
                </div>
              </RevealSection>
            ))}
          </div>

          <RevealSection delay={800}>
            <div className="text-center mt-24">
              <div className="gold-line w-48 mx-auto mb-10" />
              <p className="font-arabic text-xl text-white/45 leading-relaxed">
                كل شراكة يتم تصميمها بشكل خاص
              </p>
              <p className="font-arabic text-xl text-gold-400/70 mt-2">
                تعكس القيمة والندرة
              </p>
            </div>
          </RevealSection>
        </div>
      </section>

      {/* ===== CLOSING — HANDSHAKE ===== */}
      <section className="relative py-40 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img src={handshake} alt="" className="w-full h-full object-cover" style={{ filter: 'brightness(0.35) saturate(1.2)' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/80 via-burgundy-950/30 to-[#050505]/90" />
          <div className="cinematic-vignette absolute inset-0" />
        </div>
        {/* Gold radial glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full opacity-15 animate-gold-pulse"
             style={{ background: 'radial-gradient(circle, rgba(212,151,15,0.6) 0%, transparent 60%)' }} />

        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <RevealSection>
            <h2 className="font-arabic text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.2] mb-14">
              <span className="gold-gradient-text text-glow-gold">إذا رأيت علامتك هنا</span>
            </h2>
          </RevealSection>

          <RevealSection delay={300}>
            <div className="space-y-8">
              <p className="font-arabic text-xl md:text-2xl text-white/55 leading-relaxed">
                هذه التحديات لا تختفي
                <br />
                بل تتضاعف مع الوقت
              </p>
              <p className="font-arabic text-xl md:text-2xl text-white/85 leading-relaxed">
                إذا وجدت نفسك هنا
                <br />
                <span className="text-gold-300 font-semibold">فالخطوة الأولى هي الحديث</span>
              </p>
            </div>
          </RevealSection>

          <RevealSection delay={600}>
            <div className="mt-20">
              <div className="gold-line w-32 mx-auto mb-10" />
              <a href="mailto:anett@ahbrandhouse.com"
                 className="inline-block font-sans text-xl md:text-2xl text-gold-300 hover:text-gold-200 
                          tracking-[0.15em] transition-all duration-700 pb-3
                          border-b border-gold-600/40 hover:border-gold-400
                          hover:tracking-[0.2em]">
                anett@ahbrandhouse.com
              </a>
            </div>
          </RevealSection>

          <RevealSection delay={900}>
            <div className="mt-20 flex items-center justify-center gap-8 text-white/25 font-arabic text-base">
              <span>استشارة خاصة</span>
              <span className="w-1 h-1 rounded-full bg-gold-500/50" />
              <span>سرية</span>
              <span className="w-1 h-1 rounded-full bg-gold-500/50" />
              <span>تعاونات محدودة</span>
            </div>
          </RevealSection>

          {/* Footer */}
          <RevealSection delay={1100}>
            <div className="mt-28 pt-12 border-t border-gold-700/10">
              <img src={ahMonogram} alt="AH" className="h-12 w-auto mx-auto opacity-30" style={{ filter: 'drop-shadow(0 0 15px rgba(212,151,15,0.2))' }} />
              <p className="font-sans text-xs text-white/15 mt-6 tracking-[0.3em] uppercase">AH Brandhouse</p>
            </div>
          </RevealSection>
        </div>
      </section>
    </div>
  );
}

export default App;
